<script>
    import ErrorIcon from '../../assets/icons/ErrorIcon.svelte'
    import CloseIcon from '../../assets/icons/CloseIcon.svelte'
    import { errorBox } from '../../store/stores.js'
    import { t } from '../../i18n'

    const errorTitle = $errorBox.title
    const errorMsg = $errorBox.description

    function clearErrorBox() {
        errorBox.set({ title: '', description: ''})
    }
</script>

<div class="fixed w-full z-10 bg-error-red drop-shadow-md text-white p-4 flex justify-center items-center">
    <div>
        <ErrorIcon />
    </div>
    <div class="mx-4 text-center">
        <h3 class="inline text-lg">{$t(errorTitle)}</h3>
        <p class="inline">{$t(errorMsg)}</p>
    </div>
    <button on:click={clearErrorBox} aria-label="{$t('general.close-error-aria')}" class="border border-white rounded-full p-2">
        <CloseIcon color={'white'} />
    </button>
</div>